import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { PageHero } from "@/components/layout/PageHero";
import { ThirdPartyEntry } from "@/components/market/ThirdPartyEntry";
import { useSite } from "@/context/SiteContext";
import { AppGrid } from "@/components/apps/AppGrid";
import { usePublicApps } from "@/hooks/usePublicApps";
import { useI18n } from "@/i18n/I18nContext";
import { useState } from "react";
import { CategoryChips, byCategory } from "@/components/apps/CategoryChips";
import { PlatformChips, byPlatform } from "@/components/apps/Platform";
import { CustomPlanCta } from "@/components/apps/PlanNotes";
import { DevPanel } from "@/components/market/DevPanel";

export default function Catalogue() {
  const { apps, error } = usePublicApps();
  const { t } = useI18n();
  const { marketplace } = useSite();
  const [cat, setCat] = useState("all");
  const [plat, setPlat] = useState("all");
  const shown = byPlatform(byCategory(apps, cat), plat);
  return (
    <div data-testid="catalogue-page">
      <PageHero eyebrow={t("catalogue.eyebrow")} title={t("catalogue.title")}>
        {marketplace && <Link to="/developpeurs" className="mt-4 inline-flex items-center gap-2 text-sm text-[var(--gold)] hover:text-[var(--gold-bright)]" data-testid="catalogue-third-party-link">
          <Users className="h-4 w-4" /> {t("market.title")}
        </Link>}
      </PageHero>
      <section className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="mb-6 space-y-3"><CustomPlanCta slim testId="catalogue-custom-plan" /><ThirdPartyEntry slim testId="catalogue-third-party-entry" /><DevPanel slim testId="catalogue-dev-panel" /></div>
        <CategoryChips apps={apps} value={cat} onChange={setCat} prefix="catalogue" />
        <PlatformChips apps={apps} value={plat} onChange={setPlat} prefix="catalogue" />
        <AppGrid apps={shown} error={error} />
      </section>
    </div>
  );
}
